// src/services/materialCalculatorAPI.js

const API_BASE = "https://ideatorportal.in/api";

export async function fetchHeadings() {
  const res = await fetch(`${API_BASE}/get_headings.php`);
  return res.json();
}

export async function fetchMaterials() {
  const res = await fetch(`${API_BASE}/list_materials.php`);
  return res.json();
}

export async function fetchFormulas(headingId) {
  const res = await fetch(`${API_BASE}/get_formulas.php?heading_id=${headingId}`);
  return res.json();
}

export async function calculateMaterials(headingId, inputQty) {
  const res = await fetch(`${API_BASE}/calculate_materials.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ heading_id: headingId, input_qty: inputQty }),
  });
  return res.json();
}

export async function addHeading(data) {
  const res = await fetch(`${API_BASE}/add_heading.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return res.json();
}

export async function addMaterial(data) {
  const res = await fetch(`${API_BASE}/add_material.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  return res.json();
}

export const addFormula = async (data) => {
    try {
      const response = await fetch('https://ideatorportal.in/api/add_formula.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
  
      return await response.json();
    } catch (err) {
      console.error("Error adding formula:", err);
      return { success: false, message: "Failed to connect to server" };
    }
  };
  
